module.exports = __webpack_public_path__ + "img/d7b2eef.png";